import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RootComponent: React.FC = () => {
  const location = useLocation();
  const to = {
    pathname: '/login',
    hash: location.hash,
  };
  return <Navigate to={to} />;
};

export default RootComponent;
